import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
// import VueCookies from 'vue-cookies'

Vue.use(Vuex)
// Vue.use(VueCookies)
// base_url: 'https://www.thaimushroom.net'
const state = {
  is_login: false,
  authen: {
    token: '',
    typename: '',
    orgcode: '',
    orgname: '',
    hph_id: '',
    register_name: ''
  },
  base_url: 'https://thaimushroom.net'
}
// base_url: 'http://127.0.0.1:8000'
// base_url: 'http://www.tumdee.org/mushroom'
// สั่งการทำงานที่ mutations เดี๋ยวลองไปดูที่ console
const mutations = {
  isLogin: (state, login) => {
    // state.todos.push({ name: name })
    state.is_login = login
  },
  setAuthen: (state, data) => {
    state.authen = data
  }
}

// ส่วนของ getters เพื่อสามารถนำข้อมูลไปใช้ใน vue conponents อื่นๆได้ครับ
const getters = {
  is_login: state => state.is_login,
  getAuthen: state => state.authen,
  getBaseUrl: state => state.base_url
}

const actions = {
  submitLogin: (state, event) => {
    event.preventDefault()
    var user = event.target.hph_user.value
    var pass = event.target.hph_pass.value
    if (user === '' && pass === '') {
      alert('login:' + user + pass)
      return
    }
    // check user login
    let data = 'hph_user=' + user + '&hph_pass=' + pass
    var urlUpload = store.state.base_url + '/user_check_login.php'
    console.log(urlUpload)
    axios.post(urlUpload, data)
      .then(function (obj) {
        // alert(obj.data)
        // console.log(obj.data)
        var res = obj.data
        var response = res.response
        if (response === 'fail') {
          alert('ข้อมูลผู้ใช้งานระบบไม่ถูกต้อง')
        } else {
          var rows = res.data
          var typename = rows.typename
          if (typename === '10-ศูนย์วิชาการ') {
            let orgcode = rows.orgcode
            let orgname = rows.orgname
            let hphId = rows.hph_id
            let province = rows.province
            let csrfToken = rows.csrf_token
            let registerName = rows.register_name
            let authen = {
              orgcode: orgcode,
              orgname: orgname,
              hph_id: hphId,
              province: province,
              token: csrfToken,
              typename: typename,
              register_name: registerName
            }
            store.commit('setAuthen', authen)
            store.commit('isLogin', true)
            // this.$cookies.set('is_login', true)
            // this.$cookies.set('authen', authen)
            window.location.replace('#/addmushroom')
          } else {
            alert('ระบบยังไม่สนับสนุนการทำงานของ :' + typename)
          }
        }
      })
      .catch(function (error) {
        alert('ผิดพลาด: ' + error)
      })
  },
  clickButtonLogout: (state, control) => {
    if (window.confirm('ท่านต้องการออกจากระบบ')) {
      store.commit('isLogin', false)
      store.commit('setAuthen', {
        token: '',
        typename: '',
        orgcode: '',
        orgname: '',
        hph_id: '',
        register_name: ''
      })
      // store.state.route.path  read ok
      // store.state.route.path = '/'
      // window.location.href = '/'
      // this.$router.path({path: '/'})
      window.location.replace('#/')
    }
  }
}

let store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [createPersistedState()]
})

global.store = store
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js